const loadScript = function (src) {
  const tag = document.createElement('script');
  tag.async = false;
  tag.src = src;
  document.getElementsByTagName('body')[0].appendChild(tag);
};
let recaptchaScriptPromise;
let __recaptchaScriptPromise_res;
const recaptchaWidgetId = process.env.NIARA_APP_RECAPTCHA_SITE_KEY;
function loadRecaptchaScript() {
  if (!globalThis['grecaptcha'] && !recaptchaScriptPromise) {
    // loadScript(`//www.google.com/recaptcha/api.js?onload=_recaptchaScriptLoaded`)
    // recaptchaScriptPromise = new Promise((res, rej) => {
    //     __recaptchaScriptPromise_res = res;
    // })
    loadScript(`//www.google.com/recaptcha/api.js?onload=_recaptchaScriptLoaded&render=${recaptchaWidgetId}`);
    recaptchaScriptPromise = new Promise((res, rej) => {
      __recaptchaScriptPromise_res = res;
    });
  }
  return recaptchaScriptPromise;
}
function _recaptchaScriptLoaded() {
  // let div = document.createElement('div');
  // div.classList.add('d-print-none')
  // div.classList.add('mt-5')
  // div.classList.add('ml-2')
  // let container = document.getElementsByTagName('footer')[0] || document.getElementsByTagName('body')[0]
  // container.appendChild(div)

  // recaptchaWidgetId = window.grecaptcha.render(
  //     div,
  //     {
  //         "sitekey": process.env.NIARA_APP_RECAPTCHA_SITE_KEY,
  //         "size": "invisible",
  //         "badge": "inline"
  //     })
  __recaptchaScriptPromise_res(recaptchaWidgetId);
}
if (typeof globalThis != 'undefined') {
  globalThis['_recaptchaScriptLoaded'] = _recaptchaScriptLoaded;
}
export const disableRecaptcha = (): void => {
  // USAR PARA TESTES AUTOMÁTICOS
  globalThis['RECAPTCHA_DISABLED'] = true;
};
async function getRecaptchaToken(action): Promise<string> {
  if (globalThis['RECAPTCHA_DISABLED']) {
    // USAR PARA TESTES AUTOMÁTICOS
    return null;
  }
  if (!globalThis['grecaptcha']) {
    await loadRecaptchaScript();
  }
  const grecaptcha = globalThis['grecaptcha'];
  return await new Promise((res, rej) => {
    grecaptcha.ready(async () => {
      const token = await grecaptcha.execute(recaptchaWidgetId, action);
      res(token);
    });
  });
}
export { loadRecaptchaScript, getRecaptchaToken };
export default getRecaptchaToken;